// extracted by mini-css-extract-plugin
module.exports = {"root":"Space_root__3pvIw"};